import { mapGetters, mapActions } from 'vuex';
import base64Encode from '@/utilities/getBase64Encoding';
import CookieJar from '@/utilities/cookieJar';

import UploadList from '@/components/FormComponents/UploadList';

export const fileUploads = {
	data () {
		return {
			enableUpload: false,
			filesToUpload: [],
			uploadMsg: {
				type: null,
				text: null
			},
			loadNotesMsg: {
				type: null,
				text: null
			},
			noteSubject: '',
			uploaderValue: '',
			showList: false,
			successfulUploads: [],
			fileUploadError: false
		};
	},
    components: {
		UploadList
	},
	computed: {
		applicationType () {
			return this.stage || this.$route.meta.applicationType;
		},
		applicationTypeID () {
			const types = {
				eoi: 'ua_icexpressionofinterest',
				application: 'ua_icapplication',
				claim: 'ua_icclaim'
			};
			return types[this.applicationType];
		},
		getUploadedFiles () {
			return this.getNotesByType(this.applicationTypeID, this.noteSubject);
		},
		getAllUploadedFiles () {
			return this.getAllNotes(this.applicationTypeID);
		},
		...mapGetters('notes', ['getAllNotes', 'getNotesByType']),
		...mapGetters('eoi', ['getEOIId']),
		...mapGetters('application', ['getApplicationId', 'getApplication', 'getActiveApplication'])
	},
	mounted () {
		if (!this.getAllNotes(this.applicationTypeID).length) {
			const payload = {
				applicationTypeId: this.applicationTypeID,
				claimIdQuery: this.applicationType === 'claim' ? `&icclaimid=${this.$route.params.claimId || this.$route.query.claimId}` : ''
			};

			this.loadNotes(payload).then(res => {
				if (res === true) {
					if (this.showList) {
						this.populateList();
					}
				} else if (res.status === 422 || res.status === 500) {
					this.loadNotesMsg.type = res.type;
					this.loadNotesMsg.text = res.message;
				} else if (res.status === 401) {
					this.redeemToken({
						refreshtoken: CookieJar.get(`${process.env.VUE_APP_COOKIE_PREFIX}refresh_token`),
						businessunit: process.env.VUE_APP_BUSINESS_UNIT
					}).then((res) => {
						if (res === true) {
							this.loadNotes(payload);
							return true;
						}
						this.$router.push({ name: 'Login' });
					}).catch(() => {
						this.$router.push({ name: 'Login' });
					});
				}
			});
		}
	},
	methods: {
		prepareFiles (data, stage = null) {
			const files = Object.values(data);
			const fileList = [];

			const objectId = {
				eoi: this.getEOIId,
				application: this.applicationType !== 'eoi' ? this.getApplicationId(this.getActiveApplication) : null,
				claim: this.$route.params.claimId || this.$route.query.claimId
			};
			files.forEach(async (file) => {
				const docBody = await base64Encode(file);
				const payload = {
					subject: this.noteSubject,
					filename: file.name,
					documentbody: docBody.split(',')[1],
					objectid: objectId[this.applicationType],
					objecttypecode: this.applicationTypeID
				};
				fileList.push(payload);
			});

			this.filesToUpload = fileList;
			this.enableUpload = true;
			this.uploaderValue = data;
		},
		uploadFiles () {
			this.uploadMsg = {
				type: null,
				text: null
			};
			this.uploadNotes({ itemType: this.noteSubject, applicationType: this.applicationTypeID, data: this.filesToUpload }).then(res => {
				this.uploaderValue = '';
				this.enableUpload = false;
				if (res === true) {
					this.uploadMsg.text = 'Your files have all been uploaded successfully.';
					this.uploadMsg.type = 'success';
				} else if (res.status === 401) {
					this.redeemToken({
						refreshtoken: CookieJar.get(`${process.env.VUE_APP_COOKIE_PREFIX}refresh_token`),
						businessunit: process.env.VUE_APP_BUSINESS_UNIT
					}).then((res) => {
						if (res === true) {
							this.uploadFiles();
							return true;
						}
						this.$router.push({ name: 'Login' });
					}).catch(() => {
						this.$router.push({ name: 'Login' });
					});
				} else {
					this.uploadMsg.text = res.message;
					this.uploadMsg.type = res.type;
				}

				if (this.showList) {
					this.populateList();
				}
			}).catch(err => {
				this.uploadMsg.text = err.message;
				this.uploadMsg.type = 'error';
			});
		},
		uploadSharepointFiles () {
			this.uploadMsg = {
				type: null,
				text: null
			};
			this.successfulUploads = [];

			const promises = this.filesToUpload.map((file) => {
				return this.uploadToSharepoint(file).then(res => {
					this.uploaderValue = '';
					this.enableUpload = false;
					if (res === true) {
						this.successfulUploads.push(file.fileName);
					} else if (res.status === 401) {
						this.redeemToken({
							refreshtoken: CookieJar.get(`${process.env.VUE_APP_COOKIE_PREFIX}refresh_token`),
							businessunit: process.env.VUE_APP_BUSINESS_UNIT
						}).then((res) => {
							if (res === true) {
								this.uploadSharepointFiles();
								return true;
							}
							this.$router.push({ name: 'Login' });
						}).catch(() => {
							this.$router.push({ name: 'Login' });
						});
					} else {
						this.uploadMsg.text = res.message;
						this.uploadMsg.type = res.type;
					}
				}).catch(err => {
					this.uploadMsg.text = err.message;
					this.uploadMsg.type = 'error';
				});
			});

			Promise.all(promises).then(() => {
				this.uploadMsg.text = `The following files were uploaded successfully. ${this.successfulUploads.join(', ')}`;
				this.uploadMsg.type = 'success';
			});
		},
		...mapActions('auth', ['redeemToken']),
		...mapActions('notes', ['uploadNotes', 'loadNotes'])
	}
};
